import { forwardRef } from 'react';

import ChakraSelect from '~/common/components/Selects/Select';
import Tooltip from '~/common/components/Tooltip';

type SelectWithToolTipProps = {
  name?: string;
  options?: any[];
  input?: any;
  label?: string;
  onClick?: (...args: any[]) => any;
  placeholder?: string;
  isDisabled?: boolean;
  sx?: any;
  invalid?: string;
  onChange?: (...args: any[]) => any;
  onBlur?: (...args: any[]) => any;
  onFocus?: (...args: any[]) => any;
  dataTestId?: string;
};

const SelectWithToolTip = forwardRef<any, SelectWithToolTipProps>(
  (
    {
      name,
      options,
      input,
      label,
      onClick,
      placeholder,
      isDisabled,
      sx,
      invalid,
      onChange,
      onBlur,
      onFocus,
      dataTestId,
    },
    ref,
  ) => {
    const findLabelForTooltip = options.find((m) => m.value === input.value);

    return (
      <Tooltip
        placement="top"
        textAlign="center"
        color="black"
        bg="gray.200"
        borderRadius="2px"
        fontSize="12px"
        fontWeight="normal"
        p={2}
        label={findLabelForTooltip?.label}
      >
        <span role="tooltip" aria-label={label ?? 'Information'}>
          <ChakraSelect
            name={name}
            onClick={onClick}
            placeholder={placeholder}
            isInvalid={!!invalid}
            isDisabled={isDisabled}
            data-testid={dataTestId}
            {...input}
            onChange={(e) => {
              input.onChange(e);
              onChange?.(e);
            }}
            onBlur={(e) => {
              input.onBlur(e);
              onBlur?.(e);
            }}
            onFocus={(e) => {
              input.onFocus(e);
              onFocus?.(e);
            }}
            bg="white"
            whiteSpace={sx?.whiteSpace ? sx?.whiteSpace : 'break-spaces'}
            minHeight={'2.5rem'}
            height={'auto'}
            sx={{ ...sx }}
            {...(input.value === '' && { color: 'gray' })}
            ref={ref}
          >
            {!!options.length &&
              options.map(({ label, value }) => (
                <option
                  key={`${name}-${value}`}
                  value={value}
                  data-testid={`${dataTestId}-option`}
                >
                  {label}
                </option>
              ))}
          </ChakraSelect>
        </span>
      </Tooltip>
    );
  },
);

SelectWithToolTip.displayName = 'SelectWithToolTip';

export default SelectWithToolTip;
